<template>
<div class="organ-detail">
  <div class="user-detail">
    <div class="company-name">{{organDetail.companyName}}</div>
    <div class="depart-name">{{organDetail.middleName}}</div>
    <div class="depart-count">- {{$t('common.People').replace('XX', organDetail.count)}} -</div>
  </div>
  <svg-icon icon-class="quarter-round" class-name="quarter-round" />
</div>
</template>

<script>

export default {
  name: 'OrganDetailCompany',
  props: ['organDetail'],
}
</script>

<style scoped lang="less">
.organ-detail {
  position: relative;
  background: #F7F8FA;
  box-shadow: 5px 0 10px 0 rgba(151, 171, 199, 0.06);
}
.user-detail {
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 1;
  transform: translate3d(-50%,-50%,0);
  width: 480px;
  height: 560px;
  background-color: #fff;
  box-shadow: 0 5px 30px 0 rgba(89, 132, 219, 0.08);
  border-radius: 16px;
  border: 1px solid #EDEFF2;
  padding: 80px 77px;

  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  .company-name{
    font-size:16px;
    color: #333333;
  }
  .depart-name{
    margin: 32px 0;
    font-size:28px;
  }
  .depart-count{
    color:#999B9F;
  }
}
.quarter-round {
  width: 549px;
  height: 579px;
  position: absolute;
  right: 0;
  bottom: 0;
  z-index: 0;
}
</style>
